<template>
  <div>
    <b-card no-body>
      <b-tabs pills card>
        <b-tab :title="$t('Main')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="stateAccountingPeriod" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit && !accountingPeriodId"/>
                <b-form-invalid-feedback id="inputFeedback">
                  {{ $t('Select accounting period') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-select :options="listOfChargePolicy" v-model="selectedChargePolicy"/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormChargePolicies">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="listOfCoefficientScheme" v-model="selectedCoefficientScheme" :disabled="isEdit === true">
                <template slot="first">
                  <option :value=0></option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="ipTrafficService.cost_coef"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
              <b-input-group>
                <b-form-input type="text" v-model="ipTrafficService.charged_in_curr_period" disabled/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormCharged">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('Additional')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="datetime-local" v-model="ipTrafficService.start_date" :disabled="isEdit === true"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="datetime-local" v-model="ipTrafficService.expire_date" :disabled="infinityDate === true"/>
              <b-form-checkbox v-model="infinityDate">{{ $t('Infinity date') }}</b-form-checkbox>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="userHouse" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
                <b-input-group-append>
                  <b-button variant="secondary" size="sm" @click="clear">{{ $t('Clear') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Address comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="ipTrafficService.house_comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="ipTrafficService.comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Bandwidth limit')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
              <b-input-group>
                <b-form-input type="text" v-model="dynamicShaping" disabled/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showTurboMode">{{ $t('Turbo') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('IP groups')" :active="tabIPGroups">
          <b-row class="mb-3">
            <b-col style="margin:5px">
              <b-button @click.stop="showAddIPGroups" variant="success">{{ $t('Add') }}</b-button>
            </b-col>
          </b-row>
          <b-table small striped hover :items="IPGroups" :fields="fieldsIPGroups" @row-clicked="rowClickHandlerIPGroups">
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click.stop="ClickOnDeleteIPGroupsButton(row)" id="transparent">
                <b-img :src='deleteDocumentImage'/>
              </b-button>
              <b-button size="sm" @click.stop="ClickOnEditIPGroupsButton(row)" id="transparent">
                <b-img :src='editDocumentImage'/>
              </b-button>
            </template>
          </b-table>
        </b-tab>
        <b-tab :title="$t('Quotas')">
          <b-row class="mb-3">
            <b-col style="margin:5px">
              <b-button @click.stop="showAddQuotas" variant="success">{{ $t('Add') }}</b-button>
            </b-col>
          </b-row>
          <b-table small striped hover :items="Quotas" :fields="fieldsQuotas" @row-clicked="rowClickHandlerQuotas">
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click.stop="ClickOnDeleteQuotasButton(row)" id="transparent">
                <b-img :src='deleteDocumentImage'/>
              </b-button>
              <b-button size="sm" @click.stop="ClickOnEditQuotasButton(row)" id="transparent">
                <b-img :src='editDocumentImage'/>
              </b-button>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveServiceLink">Ok</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideSelectService">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>

    <b-modal ref="modalIPGroups" hide-footer :title="$t('IP groups')" size="lg">
      <b-card no-body>
        <b-tabs pills vertical card>
          <b-tab ref="tab_ip_settings" :title="$t('IP settings')">
            <b-col class="mt-3">
              <b-form-group label-align="right" :label="$t('IPv4 subnet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="newIPGroups.ipv4" :disabled="selectedDhcpPool !== 0 || selectedRadiusPool !== 0 || newIPGroups.ipv6 !== ''"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('IPv6 subnet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="newIPGroups.ipv6" :disabled="selectedDhcpPool !== 0 || selectedRadiusPool !== 0 || newIPGroups.ipv4 !== ''"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Dynamic')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-checkbox v-model="isDynamic" disabled/>
              </b-form-group>
            </b-col>
          </b-tab>
          <b-tab :title="$t('RADIUS settings')">
            <b-col class="mt-3">
              <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="newIPGroups.login"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="newIPGroups.password"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('RADIUS pool')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="listOfRadiusPool" v-model="selectedRadiusPool">
                  <template slot="first">
                    <option :value="0"></option>
                  </template>
                </b-form-select>
                <b-checkbox v-model="isDelegatedIPv6" v-if="this.newIPGroups.login.length && this.newIPGroups.password.length && this.isValRadiuspool">Delegated-IPv6-Prefix</b-checkbox>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Allowed CID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="newIPGroups.allowed_cid"/>
              </b-form-group>
            </b-col>
          </b-tab>
          <b-tab :title="$t('DHCP settings')">
            <b-col class="mt-3">
              <b-form-group label-align="right" :label="$t('Mac address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="newIPGroups.mac"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Switch')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-input-group>
                  <b-form-input type="text" disabled v-model="switchName" :placeholder="$t('Tap to select')"/>
                  <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showSwitch"/>
                  <b-input-group-append>
                    <b-button variant="secondary" size="sm" @click="clearSwitch">{{ $t('Clear') }}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Port')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="newIPGroups.port_id" :disabled="newIPGroups.switch_id === 0"/>
              </b-form-group>
              <b-form-group label-align="right" label="VlAN ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="newIPGroups.vlan_id" :disabled="newIPGroups.switch_id === 0"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Dynamic DHCP pool')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="listToShowOfDhcpPool" v-model="selectedDhcpPool">
                  <template slot="first">
                    <option :value="0">{{ $t('not select') }}</option>
                  </template>
                </b-form-select>
              </b-form-group>
              <b-form-group>
                <b-button variant="info" size="sm" @click="showAdditionalFeatures">{{ $t('Additional features') }}</b-button>
              </b-form-group>
            </b-col>
          </b-tab>
          <b-tab :title="$t('Additional settings')">
            <b-col class="mt-3">
              <b-form-group label-align="right" :label="$t('NetFlow provider')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="listOfNetFlow" v-model="selectedNetFlow">
                  <template slot="first">
                    <option label-align="right" :value="0" >{{ $t('Any') }} (0)</option>
                  </template>
                </b-form-select>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Not VPN IP groups')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-checkbox v-model="isNotVPN"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Do not affect firewall rules')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-checkbox v-model="isNotFirewall"/>
              </b-form-group>
            </b-col>
          </b-tab>
          <b-tab :title="$t('ISG attributes settings')">
            <b-row>
              <b-col>
                <h4 style="font-weight:bold">{{ $t('Name') }}</h4>
              </b-col>
              <b-col>
                <h4 style="font-weight:bold">{{ $t('Attribute ID') }}</h4>
              </b-col>
              <b-col>
                <h4 style="font-weight:bold">{{ $t('Vendor ID') }}</h4>
              </b-col>
              <b-col>
                <h4 style="font-weight:bold">{{ $t('Value') }}</h4>
              </b-col>
            </b-row>
            <b-row v-for="ISG in ISGattrs" v-bind:key="ISG.id" style="border-top: 1px solid #dee2e6; margin-right: 0px">
              <b-col>
                <p style="position: absolute; top: 50%; transform: translate(0, -50%)">{{ ISG.attr_name }}</p>
              </b-col>
              <b-col>
                <p style="position: absolute; top: 50%; transform: translate(0, -50%)">{{ ISG.attr_id }}</p>
              </b-col>
              <b-col>
                <p style="position: absolute; top: 50%; transform: translate(0, -50%)">{{ ISG.vendor_id }}</p>
              </b-col>
              <b-col>
                <b-input v-model="ISG.isg_attr_value" style="background-image: none"/>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addIPGroups">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideIPGroups">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteIPGroups">
      <h5>{{ $t('Do you wish to continue?') }}</h5>
      <b-row>
        <b-col>
          <b-btn variant="success" block @click="deleteIPGroup">Ok</b-btn>
        </b-col>
        <b-col>
          <b-btn variant="secondary" block @click="hideDeleteIPGroup">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="modalSwitch" hide-footer :title="$t('Selection switch')" size="lg">
      <b-table small striped hover :items="switchTable" :fields="fieldsSwitch" @row-clicked="rowClickHandlerSwitch"/>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addSwitch">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideSwitch">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="modalQuotas" hide-footer :title="$t('Quota')">
      <b-card>
        <b-form-group label-align="right" :label="$t('Traffic class')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="listOfQuotas" v-model="selectedQuotas" :disabled="isEditQuotas === true"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Quota')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="newQuotas.traffic_quota"/>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addQuotas">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideQuotas">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="modalDHCPoptions" hide-footer :title="$t('DHCP options detail')" size="lg">
      <b-row class="mb-3">
        <b-col style="margin:5px">
          <b-button @click.stop="addDHCPoptionsValues" variant="success">{{ $t('Add') }}</b-button>
        </b-col>
      </b-row>
      <b-card>
        <b-row>
          <b-col>
            <h4 style="font-weight:bold">ID</h4>
          </b-col>
          <b-col>
            <h4 style="font-weight:bold">{{ $t('Type') }}</h4>
          </b-col>
          <b-col>
            <h4 style="font-weight:bold">{{ $t('Value') }}</h4>
          </b-col>
          <b-col>
            <h4 style="font-weight:bold">{{ $t('Actions') }}</h4>
          </b-col>
        </b-row>
        <b-row v-for="item in this.DHCPoptionsValues" :key="item.optionId" style="padding: 2px">
            <b-col>
              <b-select v-model="item.option" :options="DHCPoptions"/>
            </b-col>
            <b-col>
              <b-select v-model="item.option.type" :options="DHCPoptionsType" disabled/>
            </b-col>
            <b-col>
              <b-input style="background-image: none" v-model="item.values"/>
            </b-col>
            <b-col>
              <b-button size="sm" id="transparent" @click="deleteDHCPoptionsValue(item)">
                <b-img :src='deleteDocumentImage'/>
              </b-button>
            </b-col>
          </b-row>
      </b-card>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addDHCPOptionsToIPGroup">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideAdditionalFeatures">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <FormAccountinfPeriod
      @displayAccountingPeriod="displayAccountingPeriod"
      v-model="ipTrafficService.accounting_period_id"/>

    <b-modal ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse v-model="ipTrafficService.house_id" @hideFormHouse="hideFormHouse" @displayHouse="displayHouse" @makeToasts="makeToasts"></FormHouse>
    </b-modal>

    <b-modal v-if="currentChargePolicy" ref="detailChargePolicies" hide-footer size="lg" :title="currentChargePolicy.name">
      <FormChargePolicies @hideFormChargePolicies="hideFormChargePolicies" :currentChargePolicy="currentChargePolicy"/>
    </b-modal>

    <b-modal ref="turboMode" hide-footer :title="$t('Turbo Mode')">
      <FormTurboMode :currentService="currentService" @hideTurboMode="hideTurboMode" @makeToasts="makeToasts"/>
    </b-modal>

    <b-modal ref="detailCharge" hide-footer :title="$t('Periodic service statisticsperiod')">
      <FormCharged @hideFormCharged="hideFormCharged" :currentService="currentService"/>
    </b-modal>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import moment from 'moment'
import FormAccountinfPeriod from './formAccountingPeriod'
import FormHouse from '@/pages/users/usersAndGroups/detail/contacts/formHouse.vue'
import FormChargePolicies from '@/pages/tariffication/additional/chargePolicies/editModal.vue'
import FormTurboMode from './formTurboMode'
import FormCharged from './formCharged'

export default {
  components: {
    FormAccountinfPeriod,
    FormHouse,
    FormChargePolicies,
    FormTurboMode,
    FormCharged
  },
  props: {
    tariffLinkId: 0,
    accountingPeriodId: 0,
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null
  },
  data () {
    return {
      isValRadiuspool: false,
      flagNotVPN: 1,
      flagNotFirewall: 2,
      flagDynamic: 4,
      flagDelegatedIPv6: 512,
      isNotVPN: false,
      isNotFirewall: false,
      isDynamic: false,
      isDelegatedIPv6: false,
      newDHCPoptions: {
        option: {id: 1, type: 3},
        values: ''
      },
      DHCPoptionsValues: [],
      DHCPoptionsValuesIds: 0,
      selectedAdditionalFeaturesType: '',
      DHCPoptionsType: [
        {value: 1, text: this.$i18n.t('INT')},
        {value: 2, text: this.$i18n.t('STRING')},
        {value: 3, text: 'IP'},
        {value: 4, text: this.$i18n.t('BINARY')},
        {value: 5, text: this.$i18n.t('IP_ARRAY')}
      ],
      selectedAdditionalFeatures: '',
      DHCPoptions: [
        {value: {id: 1, type: 3}, text: 'subnet-mask {derived}'},
        {value: {id: 2, type: 1}, text: 'time-offset'},
        {value: {id: 3, type: 5}, text: 'routers'},
        {value: {id: 4, type: 5}, text: 'time-servers'},
        {value: {id: 5, type: 5}, text: 'name-servers'},
        {value: {id: 6, type: 5}, text: 'domain-name-servers'},
        {value: {id: 7, type: 5}, text: 'log-servers'},
        {value: {id: 8, type: 5}, text: 'cookie-servers'},
        {value: {id: 9, type: 5}, text: 'lpr-servers'},
        {value: {id: 10, type: 5}, text: 'impress-servers'},
        {value: {id: 11, type: 5}, text: 'resource-location-servers'},
        {value: {id: 12, type: 2}, text: 'host-name'},
        {value: {id: 13, type: 4}, text: 'boot-size'},
        {value: {id: 14, type: 2}, text: 'merit-dump'},
        {value: {id: 15, type: 2}, text: 'domain-name'},
        {value: {id: 16, type: 3}, text: 'swap-server'},
        {value: {id: 17, type: 2}, text: 'root-path'},
        {value: {id: 18, type: 2}, text: 'extensions-path'},
        {value: {id: 19, type: 1}, text: 'ip-forwarding'},
        {value: {id: 20, type: 1}, text: 'non-local-source-routing'},
        {value: {id: 21, type: 5}, text: 'policy-filters'},
        {value: {id: 22, type: 4}, text: 'max-dgram-reassembly'},
        {value: {id: 23, type: 4}, text: 'default-ip-ttl'},
        {value: {id: 24, type: 1}, text: 'path-mtu-aging-timeout'},
        {value: {id: 25, type: 4}, text: 'path-mtu-plateau-tables'},
        {value: {id: 26, type: 4}, text: 'interface-mtu'},
        {value: {id: 27, type: 1}, text: 'all-subnets-local'},
        {value: {id: 28, type: 3}, text: 'broadcast-address'},
        {value: {id: 29, type: 1}, text: 'perform-mask-discovery'},
        {value: {id: 30, type: 1}, text: 'mask-supplier'},
        {value: {id: 31, type: 1}, text: 'router-discovery'},
        {value: {id: 32, type: 3}, text: 'router-solicitation-address'},
        {value: {id: 33, type: 5}, text: 'static-routes'},
        {value: {id: 34, type: 1}, text: 'trailer-encapsulation'},
        {value: {id: 35, type: 1}, text: 'arp-cache-timeout'},
        {value: {id: 36, type: 1}, text: 'ieee802.3-encapsulation'},
        {value: {id: 37, type: 4}, text: 'default-tcp-ttl'},
        {value: {id: 38, type: 1}, text: 'tcp-keepalive-interval'},
        {value: {id: 39, type: 1}, text: 'tcp-keepalive-garbage'},
        {value: {id: 40, type: 2}, text: 'nis-domain'},
        {value: {id: 41, type: 5}, text: 'nis-servers'},
        {value: {id: 42, type: 5}, text: 'ntp-servers'},
        {value: {id: 43, type: 4}, text: 'vendor-encapsulated-options'},
        {value: {id: 44, type: 5}, text: 'netbios-name-servers'},
        {value: {id: 45, type: 5}, text: 'netbios-dd-servers'},
        {value: {id: 46, type: 4}, text: 'netbios-node-type'},
        {value: {id: 47, type: 2}, text: 'netbios-scope'},
        {value: {id: 48, type: 5}, text: 'font-servers'},
        {value: {id: 49, type: 5}, text: 'x-display-managers'},
        {value: {id: 50, type: 3}, text: 'dhcp-requested-address {set by DHCP client}'},
        {value: {id: 51, type: 1}, text: 'dhcp-lease-time'},
        {value: {id: 52, type: 4}, text: 'dhcp-option-overload'},
        {value: {id: 53, type: 4}, text: 'dhcp-message-type {set by protocols}'},
        {value: {id: 54, type: 3}, text: 'dhcp-server-identifier {set by DHCP server}'},
        {value: {id: 55, type: 4}, text: 'dhcp-parameter-request-list'},
        {value: {id: 57, type: 4}, text: 'dhcp-max-message-size {set by protocol}'},
        {value: {id: 58, type: 1}, text: 'dhcp-renewal-time'},
        {value: {id: 59, type: 1}, text: 'dhcp-rebinding-time'},
        {value: {id: 60, type: 2}, text: 'dhcp-class-identifier {set by DHCP client}'},
        {value: {id: 61, type: 4}, text: 'dhcp-client-identifier {set by DHCP client}'},
        {value: {id: 62, type: 2}, text: 'netwareip-domain'},
        {value: {id: 63, type: 4}, text: 'netwareip-information'},
        {value: {id: 64, type: 2}, text: 'nis+-domain'},
        {value: {id: 65, type: 5}, text: 'nis+-servers'},
        {value: {id: 66, type: 2}, text: 'tftp-server'},
        {value: {id: 67, type: 2}, text: 'boot-file'},
        {value: {id: 68, type: 5}, text: 'mobile-ip-home-agents'},
        {value: {id: 69, type: 5}, text: 'smtp-servers'},
        {value: {id: 70, type: 5}, text: 'pop3-servers'},
        {value: {id: 71, type: 5}, text: 'nntp-servers'},
        {value: {id: 72, type: 5}, text: 'www-servers'},
        {value: {id: 73, type: 5}, text: 'finger-servers'},
        {value: {id: 74, type: 5}, text: 'irc-servers'},
        {value: {id: 75, type: 5}, text: 'streettalk-servers'},
        {value: {id: 76, type: 5}, text: 'streettalk-directory-assistance-servers'},
        {value: {id: 77, type: 2}, text: 'dhcp-user-class-id {set by DHCP client}'},
        {value: {id: 81, type: 4}, text: ' client-fqdn'},
        {value: {id: 82, type: 4}, text: 'relay-agent-info'},
        {value: {id: 85, type: 5}, text: 'nds-servers'},
        {value: {id: 86, type: 2}, text: 'nds-tree'},
        {value: {id: 87, type: 2}, text: 'nds-context'},
        {value: {id: 118, type: 3}, text: 'subnet-selection'},
        {value: {id: 121, type: 3}, text: 'classless-route'},
        {value: {id: 122, type: 4}, text: 'cablelabs-client-configuration'},
        {value: {id: 128, type: 3}, text: 'mcns-security-server'},
        {value: {id: 185, type: 4}, text: 'vpn-id'},
        {value: {id: 220, type: 4}, text: 'cisco-subnet-allocation'},
        {value: {id: 221, type: 4}, text: 'cisco-vpn-id'},
        {value: {id: 251, type: 4}, text: 'auto-configure'}
      ],
      ISGattrs: [],
      selectIPGroups: null,
      listOfQuotas: [],
      listOfNetFlow: [],
      listOfDhcpPool: [],
      listOfRadiusPool: [],
      listToShowOfDhcpPool: [],
      dynamicShapingIn: 'NA',
      dynamicShapingOut: 'NA',
      dynamicShaping: '',
      switchName: '',
      houses: null,
      currentChargePolicy: null,
      accountingPeriod: null,
      selectedQuotas: 0,
      selectedDhcpPool: 0,
      selectedNetFlow: 0,
      selectQuotas: null,
      selectedChargePolicy: '',
      selectAccountingPeriod: '',
      selectedCoefficientScheme: 0,
      userHouse: '',
      stateAccountingPeriod: false,
      selectedRadiusPool: 0,
      listOfCoefficientScheme: [],
      listOfChargePolicy: [],
      editDocumentImage: require('@/assets/img/document_edit.png'),
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      infinityDate: true,
      isEditIPGroups: false,
      isEditQuotas: false,
      isShowHouseUser: false,
      ipTrafficService: {
        'house_comment': '',
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tplink_id': 0,
        'accounting_period_id': 0,
        'start_date': moment().format('YYYY-MM-DDThh:mm'),
        'expire_date': moment().format('2033-05-18T06:33'),
        'policy_id': 0,
        'cost_coef': 100,
        'house_id': 0,
        'comment': '',
        'unabon': 0,
        'unprepay': 0,
        'ip_group': [
          {
            'ip': '0.0.0.0',
            'mask': 0,
            'mac': '',
            'login': '',
            'allowed_cid': '',
            'password': '',
            'pool_name': '',
            'flags': 0,
            'nfprovider_id': 0,
            'switch_id': 0,
            'port_id': 0,
            'vlan_id': 0,
            'pool_id': 0,
            'owner_id': 0,
            'owner_type': 0,
            'dhcp_options': [],
            'isg_attrs': []
          }
        ],
        'traffic_quota': []
      },
      empertyIPGroups: {
        'login': '',
        'password': '',
        'mac': '',
        'allowed_cid': '',
        'pool_name': '',
        'pool_id': 0,
        'switch_id': 0,
        'ip': '',
        'vlan_id': 0,
        'port_id': 0,
        'nfprovider_id': 0,
        'flags': 0,
        'ipv4': '',
        'ipv6': '',
        'dhcp_options': [],
        'isg_attrs': [],
        'mask': 0,
        'owner_id': 0,
        'owner_type': 0
      },
      newIPGroups: {
        'login': '',
        'password': '',
        'mac': '',
        'allowed_cid': '',
        'pool_name': '',
        'pool_id': 0,
        'switch_id': 0,
        'ip': '',
        'vlan_id': 0,
        'port_id': 0,
        'nfprovider_id': 0,
        'flags': 0,
        'ipv4': '',
        'ipv6': '',
        'dhcp_options': [],
        'isg_attrs': [],
        'mask': 0,
        'owner_id': 0,
        'owner_type': 0
      },
      newQuotas: {
        'tclass': 0,
        'traffic_quota': 0,
        'name': ''
      },
      empertyQuotas: {
        'tclass': 0,
        'traffic_quota': 0,
        'name': ''
      },
      tabIPGroups: false,
      ipTrafficServiceEdit: null,
      IPGroups: [],
      fieldsIPGroups: [
        {key: 'ipv4', label: this.$i18n.t('IPv4 subnet'), sortable: true},
        {key: 'ipv6', label: this.$i18n.t('IPv6 subnet'), sortable: true},
        {key: 'mac', label: this.$i18n.t('MAC address'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'allowed_cid', label: this.$i18n.t('Allowed CID'), sortable: true},
        {key: 'pool_id', label: this.$i18n.t('DHCP pool id'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      Quotas: [],
      fieldsQuotas: [
        {key: 'tclass', label: this.$i18n.t('Class ID'), sortable: true},
        {key: 'name', label: this.$i18n.t('Traffic class name'), sortable: true},
        {key: 'traffic_quota', label: this.$i18n.t('Quota'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      switchTable: [],
      fieldsSwitch: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'address', label: 'IP', sortable: true}
      ]
    }
  },
  methods: {
    deleteDHCPoptionsValue (item) {
      this.DHCPoptionsValues = this.DHCPoptionsValues.filter((el, idx, arr) => {
        return el.num !== item.num
      })
    },
    displayAccountingPeriod () {
      for (let i in this.accountingPeriod) {
        if (this.accountingPeriod[i].id === this.ipTrafficService.accounting_period_id) {
          this.accountingPeriod[i].begin = moment(Number(this.accountingPeriod[i].begin) * 1000).format('MM-DD-YYYY')
          this.accountingPeriod[i].end = moment(Number(this.accountingPeriod[i].end) * 1000).format('MM-DD-YYYY')
          this.selectAccountingPeriod = this.accountingPeriod[i].begin + ' / ' + this.accountingPeriod[i].end + ' (' + this.accountingPeriod[i].id + ')'
        }
      }
    },
    displayHouse () {
      for (let i in this.houses) {
        if (this.houses[i].house_id === this.ipTrafficService.house_id) {
          let curHouse = this.houses[i]
          delete curHouse.connect_date
          delete curHouse.house_id
          delete curHouse.zones
          for (let j in curHouse) {
            if (curHouse[j].length > 0 || curHouse[j] > 0) {
              if (this.userHouse.length > 0) {
                this.userHouse += ', '
              }
              this.userHouse += curHouse[j]
            }
          }
          break
        }
      }
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    refreshTable () {
      this.$emit('refreshTable')
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    showFormChargePolicies () {
      for (let i in this.listOfChargePolicy) {
        if (this.selectedChargePolicy === this.listOfChargePolicy[i].policy_id) {
          this.currentChargePolicy = this.listOfChargePolicy[i]
        }
      }
      this.$refs.detailChargePolicies.show()
    },
    hideFormChargePolicies () {
      this.$refs.detailChargePolicies.hide()
    },
    hideAdditionalFeatures () {
      this.$refs.modalDHCPoptions.hide()
    },
    showAdditionalFeatures () {
      this.$refs.modalDHCPoptions.show()
    },
    addDHCPoptionsValues () {
      this.newDHCPoptions.num = ++this.DHCPoptionsValuesIds
      this.DHCPoptionsValues.push(JSON.parse(JSON.stringify(this.newDHCPoptions)))
    },
    addDHCPOptionsToIPGroup () {
      let DHCP = JSON.parse(JSON.stringify(this.DHCPoptionsValues))
      for (let i in DHCP) {
        DHCP[i].id = DHCP[i].option.id
        DHCP[i].type = DHCP[i].option.type
        switch (DHCP[i].option.type) {
          case 1: {
            if (Number(DHCP[i].values)) {
              DHCP[i].value = Number(DHCP[i].values)
              delete DHCP[i].values
              delete DHCP[i].option
              break
            } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect INT format'), 'Error')
              return
            }
          }
          case 2: {
            DHCP[i].value = DHCP[i].values
            delete DHCP[i].values
            delete DHCP[i].option
            break
          }
          case 3: {
            let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
            if (DHCP[i].values.match(goodChars)) {
              DHCP[i].value = DHCP[i].values
              delete DHCP[i].values
              delete DHCP[i].option
            } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
              return
            }
            break
          }
          case 4: {
            let goodChars = '^[0-9a-fA-F]+$'
            if (DHCP[i].values.length % 2 === 0 && DHCP[i].values.match(goodChars)) {
              DHCP[i].value = DHCP[i].values
              delete DHCP[i].values
              delete DHCP[i].option
              break
            } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect BINARY format'), 'Error')
              return
            }
          }
          case 5: {
            DHCP[i].addresses = []
            let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
            DHCP[i].addresses = DHCP[i].values.split(';')
            if (DHCP[i].addresses.length) {
              let foundAddresse = DHCP[i].addresses.find(el => {
                return !el.match(goodChars)
              })
              if (foundAddresse) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP_ARRAY format'), 'Error')
                return
              }
              delete DHCP[i].values
              delete DHCP[i].option
              break
            } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP_ARRAY format'), 'Error')
              return
            }
          }
        }
      }
      this.newIPGroups.dhcp_options = DHCP
      this.hideAdditionalFeatures()
    },
    showAddIPGroups () {
      this.newIPGroups = JSON.parse(JSON.stringify(this.empertyIPGroups))
      this.isEditIPGroups = false
      this.$refs.modalIPGroups.show()
    },
    ClickOnEditIPGroupsButton (row) {
      this.selectIPGroups = row.item
      this.newIPGroups = this.selectIPGroups
      this.DHCPoptionsValues = this.newIPGroups.dhcp_options
      for (let i in this.DHCPoptionsValues) {
        this.DHCPoptionsValues[i].num = ++this.DHCPoptionsValuesIds
        this.DHCPoptionsValues[i].values = this.DHCPoptionsValues[i].value
        if (this.DHCPoptionsValues[i].addresses.length) {
          this.DHCPoptionsValues[i].values = this.DHCPoptionsValues[i].addresses.join(';')
        }
        this.DHCPoptionsValues[i].option = {}
        this.DHCPoptionsValues[i].option.id = this.DHCPoptionsValues[i].id
        this.DHCPoptionsValues[i].option.type = this.DHCPoptionsValues[i].type
      }
      if (this.newIPGroups.flags) {
        if (this.newIPGroups.flags & this.flagNotVPN) {
          this.isNotVPN = true
        }
        if (this.newIPGroups.flags & this.flagNotFirewall) {
          this.isNotFirewall = true
        }
        if (this.newIPGroups.flags & this.flagDynamic) {
          this.isDynamic = true
        }
        if (this.newIPGroups.flags & this.flagDelegatedIPv6) {
          this.isDelegatedIPv6 = true
        }
      }
      for (let i in this.listOfRadiusPool) {
        if (this.selectIPGroups.pool_name === this.listOfRadiusPool[i].name) {
          this.selectedRadiusPool = this.listOfRadiusPool[i].id
        }
      }
      for (let i in this.selectIPGroups.isg_attrs) {
        for (let j in this.ISGattrs) {
          if (this.selectIPGroups.isg_attrs[i].isg_attr_id === this.ISGattrs[j].attr_id) {
            this.ISGattrs[j].isg_attr_value = this.selectIPGroups.isg_attrs[i].isg_attr_value
          }
        }
      }
      this.selectedDhcpPool = this.newIPGroups.pool_id
      this.selectedNetFlow = this.newIPGroups.nfprovider_id
      this.isEditIPGroups = true
      this.$refs.modalIPGroups.show()
    },
    hideIPGroups () {
      this.$refs.modalIPGroups.hide()
      this.selectedDhcpPool = 0
      this.selectedNetFlow = 0
      this.selectedRadiusPool = 0
      this.switchName = ''
      this.isNotVPN = false
      this.isNotFirewall = false
      this.isDynamic = false
      this.isDelegatedIPv6 = false
      if (this.selectIPGroups) {
        if (this.selectIPGroups.ipv6 === '' && this.selectIPGroups.ipv4 === '') {
          this.selectIPGroups.ipv4 = '[Auto]'
        }
      }
      for (let i in this.ISGattrs) {
        this.ISGattrs[i].isg_attr_value = 'none'
      }
      this.DHCPoptionsValuesIds = 0
      this.DHCPoptionsValues = []
    },
    addIPGroups () {
      if (this.selectedRadiusPool === 0 && this.selectedDhcpPool === 0 && this.newIPGroups.ipv4 === '' && this.newIPGroups.ipv6 === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('You must specify at least one of subnests'), 'Error')
        this.$refs.tab_ip_settings.activate()
        return
      }
      if (!this.validationIPv4() || !this.validationIPv6()) {
        return
      }
      if (this.newIPGroups.switch_id) {
        let foundSwitch = this.switchTable.find(el => {
          return el.id === this.newIPGroups.switch_id
        })
        if (foundSwitch) {
          if (this.newIPGroups.port_id < 0 || this.newIPGroups.port_id > foundSwitch.ports_count) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect Port'), 'Error')
            return
          }
        }
      }
      if (this.newIPGroups.vlan_id < 0 || this.newIPGroups.vlan_id > 1000000000) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect VLAN ID'), 'Error')
        return
      }

      for (let i in this.listOfRadiusPool) {
        if (this.selectedRadiusPool === this.listOfRadiusPool[i].id) {
          this.newIPGroups.pool_name = this.listOfRadiusPool[i].name
        }
      }
      for (let i in this.ISGattrs) {
        this.ISGattrs[i].isg_attr_id = this.ISGattrs[i].id
      }
      this.newIPGroups.isg_attrs = this.ISGattrs
      for (let i in this.newIPGroups.isg_attrs) {
        delete this.newIPGroups.isg_attrs[i].attr_id
        delete this.newIPGroups.isg_attrs[i].attr_name
        delete this.newIPGroups.isg_attrs[i].id
        delete this.newIPGroups.isg_attrs[i].vendor_id
      }
      this.newIPGroups.pool_id = this.selectedDhcpPool
      this.newIPGroups.flags = 0
      this.newIPGroups.flags += this.isNotVPN ? this.flagNotVPN : 0
      this.newIPGroups.flags += this.isNotFirewall ? this.flagNotFirewall : 0
      this.newIPGroups.flags += this.isDynamic ? this.flagDynamic : 0
      if (this.newIPGroups.login.length && this.newIPGroups.password.length && this.isValRadiuspool) {
        this.newIPGroups.flags += this.isDelegatedIPv6 ? this.flagDelegatedIPv6 : 0
      }
      this.newIPGroups.nfprovider_id = this.selectedNetFlow
      if (!this.newIPGroups.ipv4.length && !this.newIPGroups.ipv6.length) {
        this.newIPGroups.ip = '0.0.0.0'
      }
      if (this.newIPGroups.ipv4.length) {
        this.newIPGroups.ip = this.newIPGroups.ipv4.split('/')[0]
        this.newIPGroups.mask = this.newIPGroups.ipv4.split('/')[1]
        if (!Number(this.newIPGroups.mask)) {
          this.newIPGroups.mask = 32
        }
      }
      if (this.newIPGroups.ipv6.length) {
        this.newIPGroups.ip = this.newIPGroups.ipv6.split('/')[0]
        this.newIPGroups.mask = this.newIPGroups.ipv6.split('/')[1]
        if (!Number(this.newIPGroups.mask)) {
          this.newIPGroups.mask = 128
        }
      }
      this.newIPGroups.port_id = Number(this.newIPGroups.port_id)
      this.newIPGroups.vlan_id = Number(this.newIPGroups.vlan_id)

      if (!this.isEditIPGroups) {
        this.IPGroups.push(this.newIPGroups)
      }
      this.DHCPoptionsValuesIds = 0
      this.DHCPoptionsValues = []
      this.hideIPGroups()
      this.$root.$emit('makeToasts')
    },
    ClickOnDeleteIPGroupsButton (row) {
      this.selectIPGroups = row.item
      this.$refs.modalDeleteIPGroups.show()
    },
    hideDeleteIPGroup () {
      this.$refs.modalDeleteIPGroups.hide()
    },
    deleteIPGroup () {
      this.IPGroups = this.IPGroups.filter((value) => {
        return value !== this.selectIPGroups
      })
      this.hideDeleteIPGroup()
    },
    showAddQuotas () {
      this.newQuotas = JSON.parse(JSON.stringify(this.empertyQuotas))
      this.isEditQuotas = false
      this.$refs.modalQuotas.show()
    },
    ClickOnEditQuotasButton (row) {
      this.selectQuotas = row.item
      this.newQuotas = this.selectQuotas
      this.isEditQuotas = true
      this.$refs.modalQuotas.show()
    },
    hideQuotas () {
      this.$refs.modalQuotas.hide()
    },
    ClickOnDeleteQuotasButton (row) {
      this.selectQuotas = row.item
      this.Quotas = this.Quotas.filter((value) => {
        return value !== this.selectQuotas
      })
      this.hideQuotas()
    },
    addQuotas () {
      if (this.isEditQuotas) {
        if (this.newQuotas.traffic_quota > 0) {
          this.$root.$emit('makeToasts')
          this.hideQuotas()
        }
      } else {
        let foundQuota = this.Quotas.find(el => {
          return el.tclass === this.selectedQuotas
        })
        if (!foundQuota) {
          if (this.newQuotas.traffic_quota > 0) {
            this.newQuotas.tclass = this.selectedQuotas
            for (let i in this.listOfQuotas) {
              if (this.listOfQuotas[i].tclass_id === this.selectedQuotas) {
                this.newQuotas.name = this.listOfQuotas[i].name
                break
              }
            }
            this.newQuotas.traffic_quota = Number(this.newQuotas.traffic_quota)
            this.Quotas.push(this.newQuotas)
            this.$root.$emit('makeToasts')
          } else {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Error qouta format'), 'Error')
            return
          }
          this.hideQuotas()
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add qouta value for tclass'), 'Error')
        }
      }
    },
    showTurboMode () {
      this.$refs.turboMode.show()
    },
    hideTurboMode () {
      this.$refs.turboMode.hide()
    },
    showFormCharged () {
      this.$refs.detailCharge.show()
    },
    hideFormCharged () {
      this.$refs.detailCharge.hide()
    },
    showFormAccountingPeriod () {
      this.$root.$emit('bv::show::modal', 'accoutingPeriod', '#btnShow')
    },
    showFormHouse () {
      this.isShowHouseUser = true
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.isShowHouseUser = false
      this.$refs.houseUser.hide()
    },
    clear () {
      this.userHouse = ''
      this.ipTrafficService.house_id = 0
    },
    showSwitch () {
      this.$refs.modalSwitch.show()
    },
    hideSwitch () {
      this.$refs.modalSwitch.hide()
    },
    rowClickHandlerSwitch (row) {
      if (this.selectSwitch) {
        this.selectSwitch._rowVariant = ''
      }
      this.selectSwitch = row
      this.$set(this.selectSwitch, '_rowVariant', 'info')
    },
    rowClickHandlerQuotas (row) {
      if (this.selectQuotas) {
        this.selectQuotas._rowVariant = ''
      }
      this.selectQuotas = row
      this.$set(this.selectQuotas, '_rowVariant', 'info')
    },
    addSwitch () {
      if (this.selectSwitch) {
        this.newIPGroups.switch_id = this.selectSwitch.id
        this.hideSwitch()
        this.switchName = this.selectSwitch.name
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select Switch'), 'Error')
      }
    },
    clearSwitch () {
      this.switchName = ''
      this.newIPGroups.switch_id = 0
      this.newIPGroups.vlan_id = 0
      this.newIPGroups.port_id = 0
      this.selectedDhcpPool = 0
    },
    rowClickHandlerIPGroups (row) {
      if (this.selectIPGroups) {
        this.selectIPGroups._rowVariant = ''
      }
      this.selectIPGroups = row
      for (let i in this.switchTable) {
        if (this.switchTable[i].id === this.selectIPGroups.switch_id) {
          this.switchName = this.switchTable[i].name
        }
        if (this.selectIPGroups.switch_id === 0) {
          this.switchName = ''
        }
      }
      this.$set(this.selectIPGroups, '_rowVariant', 'info')
    },
    validationIPv4 () {
      if (this.newIPGroups.ipv4 !== '') {
        let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
        let valipv4 = this.newIPGroups.ipv4.split('/')[0]
        if (valipv4.match(goodChars)) {
          return true
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
          return false
        }
      } else {
        return true
      }
    },
    validationIPv6 () {
      if (this.newIPGroups.ipv6 !== '') {
        let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
        let valipv6 = this.newIPGroups.ipv6.split('/')[0]
        if (valipv6.match(goodChars)) {
          return true
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
          return false
        }
      } else {
        return true
      }
    },
    async saveServiceLink () {
      if (this.ipTrafficService.accounting_period_id === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
      } else if (this.IPGroups.length === 0) {
        this.tabIPGroups = true
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('IP groups table is empty'), 'Error')
      } else {
        let tmpIpTrafficService = JSON.parse(JSON.stringify(this.ipTrafficService))
        for (let i in this.listOfChargePolicy) {
          if (this.selectedChargePolicy === this.listOfChargePolicy[i].value) {
            tmpIpTrafficService.policy_id = this.listOfChargePolicy[i].policy_id
          }
        }
        for (let i in this.Quotas) {
          delete this.Quotas[i].name
        }
        tmpIpTrafficService.traffic_quota = this.Quotas
        tmpIpTrafficService.cost_coef = tmpIpTrafficService.cost_coef / 100
        tmpIpTrafficService.start_date = Number(Date.parse(tmpIpTrafficService.start_date)) / 1000
        tmpIpTrafficService.expire_date = Number(Date.parse(tmpIpTrafficService.expire_date)) / 1000
        for (let i in this.IPGroups) {
          delete this.IPGroups[i].ipv4
          delete this.IPGroups[i].ipv6
          delete this.IPGroups[i]._rowVariant
        }
        tmpIpTrafficService.ip_group = this.IPGroups
        tmpIpTrafficService.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0
        if (this.isEdit) {
          tmpIpTrafficService.slink_id = this.currentService.service_link_id
          axiosInstance.put(this.$store.getters.API_USERS_SERVICELINKS_IPTRAFFIC, tmpIpTrafficService).then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$root.$emit('makeToasts')
              this.$emit('hideSelectService')
              this.$emit('refreshTable')
            }
          })
        } else {
          tmpIpTrafficService.account_id = this.selectedAccount
          tmpIpTrafficService.service_id = this.currentService.service_id
          tmpIpTrafficService.user_id = this.currentUser.user_id
          let responseSlinkId = await axiosInstance.post(this.$store.getters.API_USERS_SERVICELINKS_IPTRAFFIC, tmpIpTrafficService).then(response => { return response.data.service_link_id })
          if (responseSlinkId.error) {
            this.$root.$emit('makeToasts', 'danger', responseSlinkId.error, 'Error')
          } else {
            if (!this.selectedCoefficientScheme) {
              this.$root.$emit('makeToasts')
              this.$emit('hideSelectService')
              this.$emit('refreshTable')
            }
          }
          let newSlinkId = responseSlinkId
          if (this.selectedCoefficientScheme) {
            let foundCoefScheme = this.listOfCoefficientScheme.find(el => {
              return el.id === this.selectedCoefficientScheme
            })
            let coefSchedule = {
              items: []
            }
            for (let i in foundCoefScheme.items) {
              delete foundCoefScheme.items[i].scheme_id
              coefSchedule.items.push(foundCoefScheme.items[i])
            }
            let responseCoefScheduleId = await axiosInstance.post(this.$store.getters.API_TARIFFING_COEFFICIENT_SCHEDULE, coefSchedule).then(response => { return response.data.coefficient_schedule_id })
            if (responseCoefScheduleId.error) {
              this.$root.$emit('makeToasts', 'danger', responseCoefScheduleId.error, 'Error')
            } else {
              this.$root.$emit('makeToasts')
              this.$emit('hideSelectService')
              this.$emit('refreshTable')
            }
            let newCoefScheduleId = responseCoefScheduleId
            let ipTrafficSchedule = {
              'scheme_id': 0,
              'slink_id': 0,
              'schedule_id': 0,
              'change_policy': 0
            }
            ipTrafficSchedule.scheme_id = this.selectedCoefficientScheme
            ipTrafficSchedule.slink_id = Number(newSlinkId)
            ipTrafficSchedule.schedule_id = Number(newCoefScheduleId)
            axiosInstance.post(this.$store.getters.API_USERS_SERVICELINKS_COEFFICIENT_SCHEDULE, ipTrafficSchedule).then(response => {
              if (response.data.error) {
                this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
              } else {
                this.$root.$emit('makeToasts')
                this.$emit('hideSelectService')
                this.$emit('refreshTable')
              }
            })
          }
        }
      }
    },
    async load () {
      if (this.isEdit) {
        this.ipTrafficServiceEdit = await axiosInstance.get(this.$store.getters.API_USERS_SERVICELINKS_IPTRAFFIC + '?slink_id=' + this.currentService.service_link_id).then(response => { return response.data })
        this.ipTrafficService.comment = this.ipTrafficServiceEdit.periodicservicelink.comment
        this.ipTrafficService.start_date = moment(Number(this.ipTrafficServiceEdit.periodicservicelink.start_date) * 1000).format('YYYY-MM-DDThh:mm')
        this.ipTrafficService.expire_date = moment(Number(this.ipTrafficServiceEdit.periodicservicelink.expire_date) * 1000).format('YYYY-MM-DDThh:mm')
        this.ipTrafficService.cost_coef = this.ipTrafficServiceEdit.periodicservicelink.cost_coef * 100
        this.ipTrafficService.policy_id = this.ipTrafficServiceEdit.periodicservicelink.policy_id
        this.ipTrafficService.house_comment = this.ipTrafficServiceEdit.periodicservicelink.house_comment
        this.ipTrafficService.accounting_period_id = this.ipTrafficServiceEdit.periodicservicelink.accounting_period_id
        this.ipTrafficService.house_id = this.ipTrafficServiceEdit.periodicservicelink.house_id
        this.ipTrafficService.charged_in_curr_period = this.ipTrafficServiceEdit.periodicservicelink.charged_in_curr_period
        if (this.ipTrafficServiceEdit.bandwidth.in !== 0) {
          this.dynamicShapingIn = this.ipTrafficServiceEdit.bandwidth.in
        }
        if (this.ipTrafficServiceEdit.bandwidth.out !== 0) {
          this.dynamicShapingOut = this.ipTrafficServiceEdit.bandwidth.out
        }
        this.dynamicShaping = this.dynamicShapingIn + '/' + this.dynamicShapingOut
        this.IPGroups = this.ipTrafficServiceEdit.ip_group.items
        for (let i in this.IPGroups) {
          if (this.IPGroups[i].pool_id !== 0) {
            this.IPGroups[i].ipv4 = '[Auto]'
            this.IPGroups[i].ipv6 = ''
          } else if (this.IPGroups[i].pool_name !== '') {
            this.IPGroups[i].ipv4 = '[Auto]'
            this.IPGroups[i].ipv6 = ''
          } else {
            if (this.IPGroups[i].ip_family === 4) {
              this.IPGroups[i].ipv4 = this.IPGroups[i].ip + '/' + this.IPGroups[i].mask
              this.IPGroups[i].ipv6 = ''
            }
            if (this.IPGroups[i].ip_family === 6) {
              this.IPGroups[i].ipv6 = this.IPGroups[i].ip + '/' + this.IPGroups[i].mask
              this.IPGroups[i].ipv4 = ''
            }
          }
          if (this.ipTrafficServiceEdit.coefficientschedulelink) {
            this.selectedCoefficientScheme = this.ipTrafficServiceEdit.coefficientschedulelink.scheme_id
          }
        }
        this.Quotas = this.ipTrafficServiceEdit.iptrafficServiceLink.traffic_quota.filter(function (value) {
          return value.tclass !== 0
        })
        for (let i in this.Quotas) {
          for (let j in this.listOfQuotas) {
            if (this.Quotas[i].tclass === this.listOfQuotas[j].tclass_id) {
              this.Quotas[i].name = this.listOfQuotas[j].name
            }
          }
        }
      } else {
        this.ipTrafficService.accounting_period_id = this.accountingPeriodId ? this.accountingPeriodId : 0
      }
      this.userHouse = ''
      this.selectAccountingPeriod = ''
      this.listOfQuotas = await axiosInstance.get(this.$store.getters.API_TARIFFING_TCLASSES).then(response => { return response.data })
      let listOfCoefficientScheme = await axiosInstance.get(this.$store.getters.API_TARIFFING_COEFFICIENT_SCHEME).then(response => { return response.data })
      this.houses = await axiosInstance.get(this.$store.getters.API_REFERENCE_BOOKS_HOUSES).then(response => { return response.data })
      let listOfChargePolicy = await axiosInstance.get(this.$store.getters.API_TARIFFING_CHARGE_POLICE).then(response => { return response.data })
      this.accountingPeriod = await axiosInstance.get(this.$store.getters.API_TARIFFING_ACCOUNTING_PERIODS).then(response => { return response.data })
      this.switchTable = await axiosInstance.get(this.$store.getters.API_INVENTORY_SWITCHES).then(response => { return response.data })
      this.listOfRadiusPool = await axiosInstance.get(this.$store.getters.API_SETTINGS_ADDITIONAL_IPPOOLS).then(response => { return response.data })
      this.listOfNetFlow = await axiosInstance.get(this.$store.getters.API_SETTINGS_NETFLOW_PROVIDERS).then(response => { return response.data })
      this.listOfDhcpPool = await axiosInstance.get(this.$store.getters.API_INVENTORY_DHCP_POOLS).then(response => { return response.data })
      this.ISGattrs = await axiosInstance.get(this.$store.getters.API_SETTINGS_CUSTOM_ISG_ATTRS).then(response => { return response.data })
      this.listToShowOfDhcpPool = this.listOfDhcpPool
      for (let i in listOfChargePolicy) {
        listOfChargePolicy[i].value = listOfChargePolicy[i].policy_id
        listOfChargePolicy[i].text = listOfChargePolicy[i].name
      }
      for (let i in listOfCoefficientScheme) {
        listOfCoefficientScheme[i].value = listOfCoefficientScheme[i].id
        listOfCoefficientScheme[i].text = listOfCoefficientScheme[i].name
      }
      this.listOfCoefficientScheme = listOfCoefficientScheme
      this.listOfChargePolicy = listOfChargePolicy
      for (let i in this.listOfChargePolicy) {
        if (this.isEdit) {
          this.selectedChargePolicy = this.ipTrafficService.policy_id
        } else {
          this.selectedChargePolicy = this.listOfChargePolicy[i].value
        }
        break
      }
      for (let i in this.accountingPeriod) {
        if (this.accountingPeriod[i].id === this.ipTrafficService.accounting_period_id) {
          this.accountingPeriod[i].begin = moment(Number(this.accountingPeriod[i].begin) * 1000).format('MM-DD-YYYY')
          this.accountingPeriod[i].end = moment(Number(this.accountingPeriod[i].end) * 1000).format('MM-DD-YYYY')
          this.selectAccountingPeriod = this.accountingPeriod[i].begin + ' / ' + this.accountingPeriod[i].end + ' (' + this.accountingPeriod[i].id + ')'
        }
      }
      for (let i in this.houses) {
        if (this.houses[i].house_id === this.ipTrafficService.house_id) {
          let curHouse = this.houses[i]
          delete curHouse.connect_date
          delete curHouse.house_id
          delete curHouse.zones
          for (let j in curHouse) {
            if (curHouse[j].length > 0) {
              if (this.userHouse.length > 0) {
                this.userHouse += ', '
              }
              this.userHouse += curHouse[j]
            }
          }
          break
        }
      }
      for (let i in this.switchTable) {
        if (this.switchTable[i].id === this.newIPGroups.switch_id) {
          this.switchName = this.switchTable[i].name
        }
      }
      for (let i in this.listOfNetFlow) {
        this.listOfNetFlow[i].value = this.listOfNetFlow[i].id
        this.listOfNetFlow[i].text = this.listOfNetFlow[i].address
      }
      if (this.isEditIPGroups) {
        this.selectedNetFlow = this.newIPGroups.nfprovider_id
      }
      for (let i in this.listOfRadiusPool) {
        this.listOfRadiusPool[i].value = this.listOfRadiusPool[i].id
        this.listOfRadiusPool[i].text = this.listOfRadiusPool[i].name
      }
      for (let i in this.listOfDhcpPool) {
        this.listOfDhcpPool[i].value = this.listOfDhcpPool[i].id
        this.listOfDhcpPool[i].text = this.listOfDhcpPool[i].gateway + '/' + this.listOfDhcpPool[i].netmask + ' (' + this.listOfDhcpPool[i].id + ')'
      }
      for (let i in this.ISGattrs) {
        this.ISGattrs[i].isg_attr_value = 'none'
      }
      for (let i in this.listOfQuotas) {
        this.listOfQuotas[i].value = this.listOfQuotas[i].tclass_id
        this.listOfQuotas[i].text = this.listOfQuotas[i].name + '(' + this.listOfQuotas[i].tclass_id + ')'
      }
      for (let i in this.listOfQuotas) {
        this.selectedQuotas = this.listOfQuotas[i].tclass_id
        break
      }
      this.displayHouse()
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    selectedDhcpPool: function () {
      if (this.selectedDhcpPool !== 0) {
        this.newIPGroups.ipv4 = ''
        this.newIPGroups.ipv6 = ''
      }
    },
    selectedRadiusPool: function () {
      if (this.selectedRadiusPool !== 0) {
        this.newIPGroups.ipv4 = ''
        this.newIPGroups.ipv6 = ''
      }
      for (let el of this.listOfRadiusPool) {
        if (this.selectedRadiusPool === el.id) {
          if (el.ip.includes(':')) {
            this.isValRadiuspool = true
          } else {
            this.isValRadiuspool = false
          }
        } else {
          this.isValRadiuspool = false
        }
      }
    },
    switchName: function () {
      if (this.switchName !== '') {
        this.selectedDhcpPool = 0
      }
      for (let i in this.switchTable) {
        if (this.switchTable[i].id === this.newIPGroups.switch_id) {
          if (this.switchTable[i].dhcp_pools.length) {
            this.listToShowOfDhcpPool = this.listOfDhcpPool.filter((el) => {
              for (let j in this.switchTable[i].dhcp_pools) {
                if (this.switchTable[i].dhcp_pools[j] === el.id) {
                  return true
                }
              }
              return false
            })
          }
          break
        }
      }
    },
    selectAccountingPeriod: function (val) {
      if (this.selectAccountingPeriod.length > 0) {
        this.stateAccountingPeriod = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formIPTraffic.vue